<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Sales</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0)" @click="backParent">[{{ sales.sale_no}}]</a>
                  </li>
                  <li class="breadcrumb-item active">
                    BASTKs
                  </li>
                  <!-- <li class="breadcrumb-item">
                    <router-link :to="{ name: 'purchasing', query: { purchasing: purchasing.id, form: 'true' }}">
                      <b>[{{ purchasing.purchasing_no }}]</b>
                    </router-link>
                  </li>
                  <li class="breadcrumb-item active">
                      <span v-if="inventory.id === null">New</span>
                      <span v-else>
                        {{ inventory.inventory_no }}
                      </span>
                  </li> -->
              </ol>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <dl class="row">
                        <dt class="col-sm-3">Date</dt>
                        <dd class="col-sm-9">{{ sales.sale_date | dateFormat('DD/MM/YYYY') }}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3">Due Date</dt>
                        <dd class="col-sm-9">{{ sales.sale_due_date | dateFormat('DD/MM/YYYY') }}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3">Type</dt>
                        <dd class="col-sm-9">{{ sales.type }}</dd>
                    </dl>
                     <dl class="row">
                        <dt class="col-sm-3">Branch</dt>
                        <dd class="col-sm-9">{{ sales.branch }}</dd>
                    </dl>
                </div>
                <div class="col-md-6">
                    <dl class="row">
                        <dt class="col-sm-3">Customer</dt>
                        <dd class="col-sm-9">{{ sales.customer_no }}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3">Name</dt>
                        <dd class="col-sm-9">{{ sales.customer.name}}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3">Phone</dt>
                        <dd class="col-sm-9">{{ sales.customer.phone}}</dd>
                    </dl>
                    <dl class="row">
                        <dt class="col-sm-3">Address</dt>
                        <dd class="col-sm-9">{{ sales.customer.address}}</dd>
                    </dl>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-sm table-item table-striped">
                        <thead>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Done</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="d in salesDetail" :key="d.id" >
                                <td>[{{ d.product_no }}] {{ d.product }}</td>
                                <td>{{ d.qty }}</td>
                                <td>{{ d.qty_done }}</td>
                                <td>
                                   <button type="button" class="btn btn-outline-primary btn-sm" data-toggle="modal" data-target="#modalBstkDetail" data-backdrop="static" data-keyboard="false" @click="addBarcode(d.id)" v-if="d.canBarcode">
                                      <i class="fa fa-barcode" aria-hidden="true"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-success btn-sm" v-else @click="addDetail(d.id)">
                                      <i class="fa fa-check" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-sm btn-danger pull-left" @click="backtoSales"><i class="fa fa-reply"></i> Back</button>
          <button class="btn btn-sm btn-success dropdown-toggle pull-left" type="button" id="printsalebstk" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-print" aria-hidden="true"></i> Print
          </button>
          <div class="dropdown-menu" aria-labelledby="printsalebstk">
            <a class="dropdown-item" href="#" @click="printBstk('ellite')">BSTK</a>
            <!-- <a class="dropdown-item" href="#" @click="printBstk('callistech')">Callistech Format</a> -->
          </div>
          <button class="btn btn-sm btn-primary pull-right" @click="saveDeliver"><i class="fa fa-save"></i> Save</button>
        </div>
      </div>
      <SalesBstkDetail :sales="sales" :detail="detail" @saveBarcodeProduct="saveBarcode"/>
      <!-- <pre>{{ sales.delivers }}</pre> -->
      <!-- <pre>{{ sales }}</pre> -->
    </div>
</template>

<script>
import SalesBstkDetail from '@/components/sales/SalesBstkDetail.vue'
import Axios from 'axios'
import { getHeader, printInvoiceUrl, salesUrl, callPrintBstkUrl } from '../config'

export default {
  name: 'SalesBstk',
  components: {
    SalesBstkDetail
  },
  data () {
    return {
      detail: {
        id: null,
        sale_no: null,
        sale_date: null,
        branch_no: null,
        branch: null,
        product_no: null,
        product: null,
        description: null,
        qty: null,
        serial_number: null,
        uom_id: null,
        price: null,
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        canBarcode: false,
        state: null,
        uomType: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: '0',
          active: false,
          cost: '0',
          price: '0'
        }]
      },
      sales: {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        branch_no: null,
        branch: null,
        subtotal: null,
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        price_id: null,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          serial_number: null,
          uom_id: null,
          price: null,
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          sale_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null
        }]
      }
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.refreshBstk(id)
    } else {
      console.log('not id')
    }
  },
  computed: {
    salesDetail: function () {
      return this.sales.details.filter(d => d.id !== null)
    }
  },
  methods: {
    addDetail: function (id) {
      var d = this.sales.details.find(d => d.id === id)
      if (d.qty_done < d.qty) {
        var newID = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
        var obj = {
          id: newID,
          sale_no: d.sale_no,
          serial_number: null,
          qty: d.qty,
          product_no: d.product_no,
          branch_no: d.branch_no,
          warehouse_no: null,
          uom_id: d.uom_id
        }
        console.log(obj)
        d.qty_done = d.qty
        this.sales.delivers.push(obj)
      }
    },
    // print: function () {
    //   window.open(printInvoiceUrl + '/bstk/' + this.sales.id, '_blank')
    // },
    printBstk: function (status) {
      if (status === 'callistech') {
        window.open(callPrintBstkUrl + '/' + this.sales.id, '_blank')
      } else if (status === 'ellite') {
        window.open(printInvoiceUrl + '/bstk/' + this.sales.id, '_blank')
      }
    },
    backtoSales: function () {
      this.$router.push({ name: 'sales', query: { sales: this.sales.id } })
      console.log('back sales')
    },
    refreshBstk: function (id) {
      Axios.get(salesUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.sales = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    saveBarcode: function (value) {
      var pd = this.sales.details.find(d => d.id === value.idPDetail)
      pd.qty_done = value.qty_done
      console.log(value)
      console.log(pd)
    },
    backParent: function () {
      this.$emit('backForm', this.sales)
    },
    addBarcode: function (id) {
      this.detail = this.sales.details.find(d => d.id === id)
    },
    saveDeliver: function () {
      Axios.post(salesUrl + '/deliver/', this.sales, { headers: getHeader() })
        .then(response => {
          this.$swal(
            'Success',
            '<pre>' + response.data.message + '</pre>',
            'success'
          )
          this.backtoSales()
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data + '</pre>',
            'error'
          )
        })
    }
  }
}
</script>
